import React from 'react';
import { Link } from 'react-router-dom';
import rightArrow from '../../assets/icons/right_arrow_bar.svg'

interface BreadcrumbProps {
  path: { name: string; url: string }[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path }) => {
  return (
    <nav className='mt-1' aria-label="breadcrumb">
      <ol className="breadcrumb inline-flex text-[13px]">
        {path.map((item, index) => (
          <li
            key={index}
            className={`breadcrumb-item flex items-center ${index === path.length - 1 ? 'active' : ''}`}
            aria-current={index === path.length - 1 ? 'page' : undefined}
          >
            {index === path.length - 1 ? (
              item.name
            ) : (
              <>
                <Link to={item.url}>{item.name}</Link>
                <img src={rightArrow} className='mx-4 w-[4px]' alt="" />
              </>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;

